<template>
  <div class="cbs-flow-container">
    <!-- 筛选条件区域 -->
    <el-card class="filter-card">
      <el-form :inline="true" size="small">
        <el-form-item label="查询时间">
          <el-date-picker
            v-model="queryParams.timeRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="银行帐号">
          <el-input v-model="queryParams.accountNoList"></el-input>
        </el-form-item>

        <el-form-item label="单位编号">
          <el-input v-model="queryParams.unitCodeList"></el-input>
        </el-form-item>

        <el-form-item label="银行类型">
          <el-select
            v-model="queryParams.bankTypeList"
            multiple
            filterable
            placeholder="请选择银行类型"
            style="width: 200px;">
            <el-option
              v-for="item in bankTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="searchFlow" :loading="loading">查询</el-button>
          <el-button @click="resetQuery">重置</el-button>
          <el-button type="success" @click="showAccountList">查看银行账号列表</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 数据表格区域 -->
    <el-card class="table-card">
      <el-table
        :data="tableData"
        border
        stripe
        v-loading="loading"
        height="calc(100vh - 280px)"
        style="width: 100%">

        <!-- 核心字段展示 -->
        <el-table-column prop="trade_time" label="交易时间" width="160" fixed></el-table-column>
        <el-table-column prop="trade_no" label="交易流水号" width="180"></el-table-column>
        <el-table-column prop="account_no" label="银行账号" width="180"></el-table-column>
        <el-table-column prop="account_name" label="账户名称" width="200"></el-table-column>
        <el-table-column prop="trade_amount" label="发生额" width="120" align="right">
          <template slot-scope="scope">
            <span :class="scope.row.loan_type === '1' ? 'text-danger' : 'text-success'">
              {{ scope.row.trade_amount }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="loan_type" label="借贷类型" width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.loan_type === '1' ? 'danger' : 'success'" size="small">
              {{ scope.row.loan_type === '1' ? '借' : '贷' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="opposite_account" label="对方账号" width="180"></el-table-column>
        <el-table-column prop="opposite_name" label="对方户名" width="150"></el-table-column>
        <el-table-column prop="digest" label="摘要" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="purpose" label="用途" width="150" show-overflow-tooltip></el-table-column>

        <!-- 扩展字段(从bank_info获取) -->
        <el-table-column label="银行类型" width="100">
          <template slot-scope="scope">
            {{ scope.row.bank_info ? scope.row.bank_info.bankType : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="开户行" width="200" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.bank_info ? scope.row.bank_info.openBank : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="币种" width="80">
          <template slot-scope="scope">
            {{ scope.row.bank_info ? (scope.row.bank_info.currency === '10' ? '人民币' : scope.row.bank_info.currency) : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="交易后余额" width="120" align="right">
          <template slot-scope="scope">
            {{ scope.row.bank_info ? scope.row.bank_info.accountBalance : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="单位编码" width="100">
          <template slot-scope="scope">
            {{ scope.row.bank_info ? scope.row.bank_info.unitCode : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="单位名称" width="200" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.bank_info ? scope.row.bank_info.unitName : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="明细来源" width="100">
          <template slot-scope="scope">
            {{ scope.row.bank_info && scope.row.bank_info.detailSource === 'B' ? '银行直联' : (scope.row.bank_info && scope.row.bank_info.detailSource === 'U' ? '手工导入' : '-') }}
          </template>
        </el-table-column>
        <el-table-column label="对账状态" width="100">
          <template slot-scope="scope">
            {{ scope.row.bank_info ? getCheckTypeText(scope.row.bank_info.checkType) : '-' }}
          </template>
        </el-table-column>

        <!-- 操作列 -->
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="viewDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <el-pagination
        @current-change="handlePageChange"
        :current-page.sync="pagination.page"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        layout="total, prev, pager, next, jumper"
        style="margin-top: 20px; text-align: right;">
      </el-pagination>
    </el-card>

    <!-- 详情对话框 -->
    <el-dialog title="流水详情" :visible.sync="detailVisible" width="80%">
      <div v-if="currentRow && currentRow.bank_info">
        <!-- 基础信息 -->
        <el-card class="detail-section" shadow="never">
          <div slot="header" class="section-header">基础信息</div>
          <el-descriptions :column="3" border size="small">
            <el-descriptions-item label="交易流水号">{{ currentRow.bank_info.transactionSerialNumber }}</el-descriptions-item>
            <el-descriptions-item label="银行流水号">{{ currentRow.bank_info.bankSerialNumber || '-' }}</el-descriptions-item>
            <el-descriptions-item label="唯一键">{{ currentRow.bank_info.uniqueKey }}</el-descriptions-item>
            <el-descriptions-item label="原始流水号">{{ currentRow.bank_info.originalSerialNumber || '-' }}</el-descriptions-item>
            <el-descriptions-item label="结算流水号">{{ currentRow.bank_info.settlementSerialNumber || '-' }}</el-descriptions-item>
            <el-descriptions-item label="直连流水号">{{ currentRow.bank_info.directSerialNumber || '-' }}</el-descriptions-item>
            <el-descriptions-item label="交易时间">{{ currentRow.trade_time }}</el-descriptions-item>
            <el-descriptions-item label="起息日">{{ currentRow.bank_info.valueDate ? formatTimestamp(currentRow.bank_info.valueDate) : '-' }}</el-descriptions-item>
            <el-descriptions-item label="记账日期">{{ currentRow.bank_info.bookingDate ? formatTimestamp(currentRow.bank_info.bookingDate) : '-' }}</el-descriptions-item>
          </el-descriptions>
        </el-card>

        <!-- 账户信息 -->
        <el-card class="detail-section" shadow="never">
          <div slot="header" class="section-header">账户信息</div>
          <el-descriptions :column="3" border size="small">
            <el-descriptions-item label="银行账号">{{ currentRow.bank_info.accountNo }}</el-descriptions-item>
            <el-descriptions-item label="账户名称">{{ currentRow.bank_info.accountName }}</el-descriptions-item>
            <el-descriptions-item label="开户行">{{ currentRow.bank_info.openBank || '-' }}</el-descriptions-item>
            <el-descriptions-item label="银行类型">{{ currentRow.bank_info.bankType }}</el-descriptions-item>
            <el-descriptions-item label="账户性质">{{ currentRow.bank_info.accountNature || '-' }}</el-descriptions-item>
            <el-descriptions-item label="账户状态">
              {{ currentRow.bank_info.accountStatus === '0' ? '正常' : '注销' }}
            </el-descriptions-item>
            <el-descriptions-item label="币种">
              {{ currentRow.bank_info.currency === '10' ? '人民币' : currentRow.bank_info.currency }}
            </el-descriptions-item>
            <el-descriptions-item label="虚拟户账号">{{ currentRow.bank_info.virtualAccount || '-' }}</el-descriptions-item>
            <el-descriptions-item label="虚拟户名称">{{ currentRow.bank_info.virtualAccountName || '-' }}</el-descriptions-item>
          </el-descriptions>
        </el-card>

        <!-- 金额信息 -->
        <el-card class="detail-section" shadow="never">
          <div slot="header" class="section-header">金额信息</div>
          <el-descriptions :column="3" border size="small">
            <el-descriptions-item label="发生额">
              <span :class="currentRow.bank_info.loanType === '1' ? 'text-danger' : 'text-success'" style="font-weight: bold; font-size: 16px;">
                {{ currentRow.bank_info.incurredAmount }}
              </span>
            </el-descriptions-item>
            <el-descriptions-item label="借贷类型">
              <el-tag :type="currentRow.bank_info.loanType === '1' ? 'danger' : 'success'" size="medium">
                {{ currentRow.bank_info.loanType === '1' ? '借' : '贷' }}
              </el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="交易后余额">{{ currentRow.bank_info.accountBalance || '-' }}</el-descriptions-item>
            <el-descriptions-item label="交易服务费">{{ currentRow.bank_info.transactionFee || '-' }}</el-descriptions-item>
            <el-descriptions-item label="服务费率">{{ currentRow.bank_info.transactionFeeRate || '-' }}</el-descriptions-item>
            <el-descriptions-item label="交易金额">{{ currentRow.bank_info.transactionAmount || '-' }}</el-descriptions-item>
          </el-descriptions>
        </el-card>

        <!-- 对方信息 -->
        <el-card class="detail-section" shadow="never">
          <div slot="header" class="section-header">对方信息</div>
          <el-descriptions :column="3" border size="small">
            <el-descriptions-item label="对方账号">{{ currentRow.bank_info.oppositeAccount || '-' }}</el-descriptions-item>
            <el-descriptions-item label="对方户名">{{ currentRow.bank_info.oppositeName || '-' }}</el-descriptions-item>
            <el-descriptions-item label="对方开户行">{{ currentRow.bank_info.oppositeOpeningBank || '-' }}</el-descriptions-item>
          </el-descriptions>
        </el-card>

        <!-- 业务信息 -->
        <el-card class="detail-section" shadow="never">
          <div slot="header" class="section-header">业务信息</div>
          <el-descriptions :column="2" border size="small">
            <el-descriptions-item label="摘要">{{ currentRow.bank_info.digest || '-' }}</el-descriptions-item>
            <el-descriptions-item label="用途">{{ currentRow.bank_info.purpose || '-' }}</el-descriptions-item>
            <el-descriptions-item label="备注">{{ currentRow.bank_info.remark || '-' }}</el-descriptions-item>
            <el-descriptions-item label="附言">{{ currentRow.bank_info.postscript || '-' }}</el-descriptions-item>
            <el-descriptions-item label="交易代码">{{ currentRow.bank_info.transactionCode || '-' }}</el-descriptions-item>
            <el-descriptions-item label="交易代码名称">{{ currentRow.bank_info.transactionCodeName || '-' }}</el-descriptions-item>
            <el-descriptions-item label="款项性质代码">{{ currentRow.bank_info.paymentNature || '-' }}</el-descriptions-item>
            <el-descriptions-item label="款项性质标记">
              {{ getPaymentNatureFlagText(currentRow.bank_info.paymentNatureFlag) }}
            </el-descriptions-item>
            <el-descriptions-item label="明细类型">
              {{ currentRow.bank_info.detailType === '1' ? '当日明细' : '历史明细' }}
            </el-descriptions-item>
            <el-descriptions-item label="明细来源">
              {{ currentRow.bank_info.detailSource === 'B' ? '银行直联' : (currentRow.bank_info.detailSource === 'U' ? '手工导入' : '-') }}
            </el-descriptions-item>
          </el-descriptions>
        </el-card>

        <!-- 单位与对账信息 -->
        <el-card class="detail-section" shadow="never">
          <div slot="header" class="section-header">单位与对账信息</div>
          <el-descriptions :column="3" border size="small">
            <el-descriptions-item label="单位编码">{{ currentRow.bank_info.unitCode }}</el-descriptions-item>
            <el-descriptions-item label="单位名称">{{ currentRow.bank_info.unitName }}</el-descriptions-item>
            <el-descriptions-item label="显示单位编码">{{ currentRow.bank_info.displayUnitCode || '-' }}</el-descriptions-item>
            <el-descriptions-item label="对账码">{{ currentRow.bank_info.checkCode || '-' }}</el-descriptions-item>
            <el-descriptions-item label="对账状态">
              {{ getCheckTypeText(currentRow.bank_info.checkType) }}
            </el-descriptions-item>
            <el-descriptions-item label="关联客户号">{{ currentRow.bank_info.associatedCustomerNumber || '-' }}</el-descriptions-item>
            <el-descriptions-item label="科目代码">{{ currentRow.bank_info.subjectCode || '-' }}</el-descriptions-item>
            <el-descriptions-item label="凭证编号">{{ currentRow.bank_info.voucherCode || '-' }}</el-descriptions-item>
            <el-descriptions-item label="业务参考号">{{ currentRow.bank_info.businessReferenceCode || '-' }}</el-descriptions-item>
          </el-descriptions>
        </el-card>

        <!-- ERP与扩展信息(可折叠) -->
        <el-collapse v-model="activeCollapse">
          <el-collapse-item name="erp">
            <template slot="title">
              <span style="font-weight: bold;">ERP与扩展信息 (点击展开)</span>
            </template>
            <el-descriptions :column="2" border size="small">
              <el-descriptions-item label="ERP业务参考号">{{ currentRow.bank_info.erpSerialNumber || '-' }}</el-descriptions-item>
              <el-descriptions-item label="客商编号">{{ currentRow.bank_info.merchantNumber || '-' }}</el-descriptions-item>
              <el-descriptions-item label="客商名称">{{ currentRow.bank_info.merchantName || '-' }}</el-descriptions-item>
              <el-descriptions-item label="交易识别码">{{ currentRow.bank_info.corporateIdentityCode || '-' }}</el-descriptions-item>
              <el-descriptions-item label="母公司账号">{{ currentRow.bank_info.parentSubCompanyAccount || '-' }}</el-descriptions-item>
              <el-descriptions-item label="母公司名称">{{ currentRow.bank_info.parentSubCompanyName || '-' }}</el-descriptions-item>
              <el-descriptions-item label="交易类型">{{ currentRow.bank_info.protocolTypeName || '-' }}</el-descriptions-item>
              <el-descriptions-item label="退票原因">{{ currentRow.bank_info.refundReason || '-' }}</el-descriptions-item>
              <el-descriptions-item label="批次序列号">{{ currentRow.bank_info.serialNo || '-' }}</el-descriptions-item>
              <el-descriptions-item label="更新时间">{{ currentRow.bank_info.updateTime ? formatTimestamp(currentRow.bank_info.updateTime) : '-' }}</el-descriptions-item>
            </el-descriptions>

            <!-- 支付申请备注 -->
            <div v-if="hasPayApplyRemarks" style="margin-top: 15px;">
              <div style="font-weight: bold; margin-bottom: 10px;">支付申请备注:</div>
              <el-descriptions :column="1" border size="small">
                <el-descriptions-item label="备注1">{{ currentRow.bank_info.payApplyRemark1 || '-' }}</el-descriptions-item>
                <el-descriptions-item label="备注2">{{ currentRow.bank_info.payApplyRemark2 || '-' }}</el-descriptions-item>
                <el-descriptions-item label="备注3">{{ currentRow.bank_info.payApplyRemark3 || '-' }}</el-descriptions-item>
                <el-descriptions-item label="备注4">{{ currentRow.bank_info.payApplyRemark4 || '-' }}</el-descriptions-item>
                <el-descriptions-item label="备注5">{{ currentRow.bank_info.payApplyRemark5 || '-' }}</el-descriptions-item>
              </el-descriptions>
            </div>

            <!-- 个性化字段 -->
            <div v-if="hasPersonalizeFields" style="margin-top: 15px;">
              <div style="font-weight: bold; margin-bottom: 10px;">银行个性化字段:</div>
              <el-descriptions :column="1" border size="small">
                <el-descriptions-item label="个性化字段1">
                  <div v-html="decodeHtml(currentRow.bank_info.personalizeField1)"></div>
                </el-descriptions-item>
                <el-descriptions-item label="个性化字段2">{{ currentRow.bank_info.personalizeField2 || '-' }}</el-descriptions-item>
                <el-descriptions-item label="个性化字段3">{{ currentRow.bank_info.personalizeField3 || '-' }}</el-descriptions-item>
                <el-descriptions-item label="个性化字段4">{{ currentRow.bank_info.personalizeField4 || '-' }}</el-descriptions-item>
                <el-descriptions-item label="个性化字段5">{{ currentRow.bank_info.personalizeField5 || '-' }}</el-descriptions-item>
              </el-descriptions>
            </div>

            <!-- 预留字段 -->
            <div v-if="hasReserveFields" style="margin-top: 15px;">
              <div style="font-weight: bold; margin-bottom: 10px;">预留字段:</div>
              <el-descriptions :column="2" border size="small">
                <el-descriptions-item label="预留字段1">{{ currentRow.bank_info.reserveField1 || '-' }}</el-descriptions-item>
                <el-descriptions-item label="预留字段2">{{ currentRow.bank_info.reserveField2 || '-' }}</el-descriptions-item>
                <el-descriptions-item label="预留字段3">{{ currentRow.bank_info.reserveField3 || '-' }}</el-descriptions-item>
                <el-descriptions-item label="预留字段4">{{ currentRow.bank_info.reserveField4 || '-' }}</el-descriptions-item>
              </el-descriptions>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </el-dialog>

    <!-- 账户列表弹框 -->
    <el-dialog title="银行账号列表" :visible.sync="accountDialogVisible" width="90%">
      <!-- 筛选条件 -->
      <el-form :inline="true" size="small" style="margin-bottom: 15px;">
        <el-form-item label="银行类型">
          <el-select
            v-model="accountQueryParams.bankTypeList"
            multiple
            filterable
            placeholder="请选择银行类型"
            style="width: 200px;">
            <el-option
              v-for="item in bankTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="银行账号">
          <el-input v-model="accountQueryParams.accountNo" placeholder="请输入银行账号" style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item label="机构编号">
          <el-input v-model="accountQueryParams.unitCodeList"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchAccountList" :loading="accountLoading">查询</el-button>
          <el-button @click="resetAccountQuery">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- 账户列表表格 -->
      <el-table
        :data="accountTableData"
        border
        stripe
        v-loading="accountLoading"
        height="500"
        style="width: 100%">
        <el-table-column prop="accountNo" label="银行账号" width="180"></el-table-column>
        <el-table-column prop="accountName" label="账户名称" width="200"></el-table-column>
        <el-table-column prop="openBank" label="开户行" width="250" show-overflow-tooltip></el-table-column>
        <el-table-column prop="bankTypeName" label="银行类型" width="120"></el-table-column>
        <el-table-column prop="currencyName" label="币种" width="80"></el-table-column>
        <el-table-column prop="accountStatus" label="账户状态" width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.accountStatus === '0' ? 'success' : 'info'" size="small">
              {{ scope.row.accountStatus === '0' ? '正常' : '销户' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="unitCode" label="单位编码" width="100"></el-table-column>
        <el-table-column prop="unitName" label="单位名称" width="200" show-overflow-tooltip></el-table-column>
        <el-table-column prop="depositType" label="存款类型" width="80">
          <template slot-scope="scope">
            {{ getDepositTypeText(scope.row.depositType) }}
          </template>
        </el-table-column>
        <el-table-column prop="directConnectFlagName" label="直联标志" width="100"></el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <el-pagination
        @current-change="handleAccountPageChange"
        :current-page.sync="accountPagination.page"
        :page-size="accountPagination.pageSize"
        :total="accountPagination.total"
        layout="total, prev, pager, next, jumper"
        style="margin-top: 20px; text-align: right;">
      </el-pagination>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'CbsFlow',
  data() {
    return {
      // 查询参数
      queryParams: {
        timeRange: [],
        startDate: '',
        endDate: '',
        // 预留扩展字段
        accountNoList: '',
        unitCodeList: '',
        bankTypeList: [],

      },
      bankTypeOptions: [], // 银行类型选项列表

      // 账户列表相关
      accountDialogVisible: false, // 账户列表弹框显示状态
      accountLoading: false, // 账户列表加载状态
      accountQueryParams: {
        bankTypeList: [],
        accountNo: '',
        unitCodeList : [],
      },
      accountTableData: [], // 账户列表数据
      accountPagination: {
        page: 1,
        pageSize: 20,
        total: 0
      },

      // 日期选择器限制(不能超过1年)
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.choiceDate = minDate.getTime();
          if (maxDate) {
            this.choiceDate = '';
          }
        },
        disabledDate: (time) => {
          if (this.choiceDate) {
            const oneYear = 365 * 24 * 3600 * 1000;
            const minTime = this.choiceDate - oneYear;
            const maxTime = this.choiceDate + oneYear;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
        }
      },
      choiceDate: '',

      // 表格数据
      tableData: [],
      loading: false,

      // 分页
      pagination: {
        page: 1,
        pageSize: 20,
        total: 0
      },

      // 详情对话框
      detailVisible: false,
      currentRow: null,
      activeCollapse: [] // 折叠面板激活项
    };
  },

  computed: {
    // 是否有支付申请备注
    hasPayApplyRemarks() {
      if (!this.currentRow || !this.currentRow.bank_info) return false;
      return this.currentRow.bank_info.payApplyRemark1 || this.currentRow.bank_info.payApplyRemark2 ||
             this.currentRow.bank_info.payApplyRemark3 || this.currentRow.bank_info.payApplyRemark4 ||
             this.currentRow.bank_info.payApplyRemark5;
    },
    // 是否有个性化字段
    hasPersonalizeFields() {
      if (!this.currentRow || !this.currentRow.bank_info) return false;
      return this.currentRow.bank_info.personalizeField1 || this.currentRow.bank_info.personalizeField2 ||
             this.currentRow.bank_info.personalizeField3 || this.currentRow.bank_info.personalizeField4 ||
             this.currentRow.bank_info.personalizeField5;
    },
    // 是否有预留字段
    hasReserveFields() {
      if (!this.currentRow || !this.currentRow.bank_info) return false;
      return this.currentRow.bank_info.reserveField1 || this.currentRow.bank_info.reserveField2 ||
             this.currentRow.bank_info.reserveField3 || this.currentRow.bank_info.reserveField4;
    }
  },

  created() {
    // 默认查询昨天到今天的数据
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const today = new Date();

    this.queryParams.timeRange = [
      this.formatDate(yesterday),
      this.formatDate(today)
    ];

    // 加载银行类型列表
    this.loadBankTypeList();

    // 自动查询
    this.searchFlow();
  },

  methods: {
    // 加载银行类型列表
    loadBankTypeList() {
      this.$myhttp.post('admin/cbsBankType', {}, {
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(res => {
        if (res.data.code === 200) {
          this.bankTypeOptions = res.data.data || [];
        } else {
          console.error('加载银行类型列表失败:', res.data.msg);
        }
      }).catch(err => {
        console.error('加载银行类型列表异常:', err);
      });
    },

    // 显示账户列表弹框
    showAccountList() {
      this.accountDialogVisible = true;
      // 如果还没有加载过账户数据，则自动查询
      if (this.accountTableData.length === 0) {
        this.searchAccountList();
      }
    },

    // 查询账户列表
    searchAccountList() {
      this.accountLoading = true;
      const params = {
        bankTypeList: this.accountQueryParams.bankTypeList.length > 0 ? this.accountQueryParams.bankTypeList : undefined,
        accountNo: this.accountQueryParams.accountNo || undefined,
        unitCodeList : this.accountQueryParams.unitCodeList || undefined,
        pageNum: this.accountPagination.page,
        pageSize: this.accountPagination.pageSize
      };

      this.$myhttp.post('admin/cbsAccountList', params, {
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(res => {
        this.accountLoading = false;
        if (res.data.code === 200) {
          this.accountTableData = res.data.data.list || [];
          this.accountPagination.total = res.data.data.total || 0;

          if (this.accountTableData.length === 0) {
            this.$message.info('暂无账户数据');
          }
        } else {
          this.$message.error(res.data.msg || '查询失败');
        }
      }).catch(err => {
        this.accountLoading = false;
        this.$message.error('请求异常');
        console.error(err);
      });
    },

    // 重置账户查询
    resetAccountQuery() {
      this.accountQueryParams.bankTypeList = [];
      this.accountQueryParams.accountNo = '';
      this.accountPagination.page = 1;
      this.searchAccountList();
    },

    // 账户列表分页切换
    handleAccountPageChange(page) {
      this.accountPagination.page = page;
      this.searchAccountList();
    },

    // 获取存款类型文本
    getDepositTypeText(depositType) {
      const map = {
        'A': '活期',
        'C': '协定',
        'F': '定期',
        'N': '通知'
      };
      return map[depositType] || depositType || '-';
    },

    // 格式化日期
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    // 查询流水
    searchFlow() {
      if (!this.queryParams.timeRange || this.queryParams.timeRange.length !== 2) {
        this.$message.warning('请选择查询时间范围');
        return;
      }

      this.queryParams.startDate = this.queryParams.timeRange[0];
      this.queryParams.endDate = this.queryParams.timeRange[1];

      this.loading = true;
      const params = {
        channel: 'CBS',
        pid: 0, // CBS不需要项目ID,传0即可
        start_time: this.queryParams.startDate + ' 00:00:00',
        end_time: this.queryParams.endDate + ' 23:59:59',
        pos_no: '', // CBS不需要POS号
        page: this.pagination.page,
        extendParams: {
          bankTypeList: this.queryParams.bankTypeList.length > 0 ? this.queryParams.bankTypeList : undefined ,
          accountNoList : this.queryParams.accountNoList !== '' ? this.queryParams.accountNoList : undefined ,
          unitCodeList : this.queryParams.unitCodeList !== '' ? this.queryParams.unitCodeList : undefined ,
        }
      };

      this.$myhttp.post('admin/OrderOnlineBankFlowList', params, {
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(res => {
        this.loading = false;
        if (res.data.code === 200) {
          this.tableData = res.data.data.list || [];
          this.pagination.total = (res.data.data.page_count || 0) * this.pagination.pageSize;

          if (this.tableData.length === 0) {
            this.$message.info('暂无数据');
          }
        } else {
          this.$message.error(res.data.msg || '查询失败');
        }
      }).catch(err => {
        this.loading = false;
        this.$message.error('请求异常');
        console.error(err);
      });
    },

    // 重置查询
    resetQuery() {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      const today = new Date();

      this.queryParams.timeRange = [
        this.formatDate(yesterday),
        this.formatDate(today)
      ];
      this.pagination.page = 1;
      this.searchFlow();
    },

    // 分页切换
    handlePageChange(page) {
      this.pagination.page = page;
      this.searchFlow();
    },

    // 查看详情
    viewDetail(row) {
      this.currentRow = row;
      this.activeCollapse = []; // 默认折叠扩展信息
      this.detailVisible = true;
    },

    // 格式化时间戳
    formatTimestamp(timestamp) {
      if (!timestamp) return '-';
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    // 获取对账状态文本
    getCheckTypeText(checkType) {
      const map = {
        '0': '未对账',
        '1': '自动对账',
        '2': '手工对账',
        '3': '自动对账(退票)',
        '4': '手工对账(退票)',
        '5': '对账中(退票)',
        '6': '自动对账(外汇)',
        '7': '手工对账(外汇)'
      };
      return map[checkType] || checkType || '-';
    },

    // 获取款项性质标记文本
    getPaymentNatureFlagText(flag) {
      const map = {
        '1': '未匹配',
        '2': '手工处理',
        '3': '系统处理',
        '4': '匹配失败'
      };
      return map[flag] || flag || '-';
    },

    // 解码HTML实体
    decodeHtml(html) {
      if (!html) return '-';
      const txt = document.createElement('textarea');
      txt.innerHTML = html;
      return txt.value;
    }
  }
};
</script>

<style scoped>
.cbs-flow-container {
  padding: 20px;
}

.filter-card {
  margin-bottom: 20px;
}

.table-card {
  min-height: calc(100vh - 280px);
}

.text-success {
  color: #67c23a;
  font-weight: bold;
}

.text-danger {
  color: #f56c6c;
  font-weight: bold;
}

.detail-section {
  margin-bottom: 15px;
}

.section-header {
  font-weight: bold;
  font-size: 14px;
  color: #303133;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/CbsFlow.vue